<template>
	<ParamWrapper v-bind="wrapperProps">
		<codemirror v-model="codeBlockVal" :options="cmOptions" class="CodeMirror" />
	</ParamWrapper>
</template>

<script>
import { setIsSideBarDrawerOpen } from '@/store/modules/sideBarDrawer/actions';
import { isAiCodeGeneratorEnabled } from '@/store/modules/featureFlags/getters';
import { getNode } from '@/store/modules/nodes/getters';
import { setIsShowKnob } from '@/store/modules/sideBarDrawer/actions';
import { createAssistantThread } from '@/store/modules/aiAssistantApiDocs/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { updateNodeData } from '@/store/modules/nodes/actions';

import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/theme/darcula.css';
import { codemirror } from 'vue-codemirror';
import ParamTypeMixin from './mixins/ParamTypeMixin';
const INITIAL_VALUE = `function addOne (num) {
  return num + 1;
}
return addOne(5);`;

export default {
	name: 'CodeBlockParamType',
	mixins: [ParamTypeMixin],
	components: { codemirror },
	computed: {
		...mapGettersShorthand({ isAiCodeGeneratorEnabled, getNode }),
		isAiFeatureFlagOn() {
			return this.isAiCodeGeneratorEnabled;
		},
		codeBlockVal: {
			set(value) {
				this.localValue = { ...this.localValue, code_block_val: value }; // Have to assign to localValue for it to activate localValue watcher, not localValue.code_block_val = value
			},
			get() {
				return this.localValue?.code_block_val || '';
			},
		},
	},
	beforeDestroy() {
		this.setIsShowKnob(false);
	},
	methods: {
		...mapActionsShorthand({ setIsShowKnob, createAssistantThread, setIsSideBarDrawerOpen, updateNodeData }),
		async createThread() {
			const nodeId = this.node.id;
			const { thread_id: threadId } = await this.createAssistantThread({ nodeId });
			// Save updated node after changing it's thread id
			const nodeBeforeUpdate = this.getNode(nodeId);
			const updatedNode = { ...nodeBeforeUpdate, ai_assistant_thread_id: threadId };
			await this.updateNodeData({ data: updatedNode });
		},
	},
	data() {
		return {
			cmOptions: {
				mode: 'javascript', // { name: "javascript", json: true }
				theme: 'darcula',
				lineNumbers: true,
				spellcheck: true,
				matchingbrackets: true,
				autoCloseBrackets: true,
				lineWrapping: true,
				'font-size': '50%',
			},
		};
	},
	async mounted() {
		if (this.node.temp) {
			return;
		}
		if (this.localValue && typeof this.localValue === 'string') {
			this.localValue = { code_block_val: this.localValue };
		}
		if (!this.node.ai_assistant_thread_id && !this.localValue) {
			this.localValue = { code_block_val: INITIAL_VALUE };
			await this.createThread();
		}
		if (this.isAiFeatureFlagOn) {
			this.setIsShowKnob(true);
			this.setIsSideBarDrawerOpen(true);
		}
	},
};
</script>
<style lang="scss" scoped>
.CodeMirror {
	font-size: 14px;
}
</style>
